import React from 'react';
import PropTypes from 'prop-types';
import { DeviceIndicator, Indicator, ToggleDeviceBackground } from './DeviceToggleStyles';
import { DEVICE_TYPES } from '../../constants/enums';
import MobileIcon from '../../assets/mobile.svg';
import TablteIcon from '../../assets/tablet.svg';
import DesktopIcon from '../../assets/desktop.svg';

const FormDeviceToggle = (props) => {
  const { deviceMode, changeDevice } = props;

  const onDeviceClick = (deviceType) => {
    if (deviceType === deviceMode) {
      return;
    }
    changeDevice(deviceType);
  };

  return (
    <ToggleDeviceBackground
      role="radiogroup"
      aria-orientation="horizontal"
      data-aut="deviceToggle"
    >
      <button
        type="button"
        role="radio"
        aria-checked={deviceMode === DEVICE_TYPES.DESKTOP}
        className={deviceMode === DEVICE_TYPES.DESKTOP && 'active'}
        onClick={() => onDeviceClick(DEVICE_TYPES.DESKTOP)}
      >
        <img src={DesktopIcon} alt='desktop icon' />&nbsp;
        <span>Desktop</span>
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={deviceMode === DEVICE_TYPES.TABLET}
        className={deviceMode === DEVICE_TYPES.TABLET && 'active'}
        onClick={() => onDeviceClick(DEVICE_TYPES.TABLET)}
      >
        <img src={TablteIcon} alt='tablet icon' />&nbsp;
        <span>Tablet</span>
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={deviceMode === DEVICE_TYPES.MOBILE}
        className={deviceMode === DEVICE_TYPES.MOBILE && 'active'}
        onClick={() => onDeviceClick(DEVICE_TYPES.MOBILE)}
      >
        <img src={MobileIcon} alt='mobile icon' />&nbsp;
        <span>Mobile</span>
      </button>
      <DeviceIndicator activeItem={deviceMode}></DeviceIndicator>
    </ToggleDeviceBackground>
  );
};

FormDeviceToggle.propTypes = {
  deviceMode: PropTypes.oneOf([
    DEVICE_TYPES.MOBILE,
    DEVICE_TYPES.TABLET,
    DEVICE_TYPES.DESKTOP
  ]),
  changeDevice: PropTypes.func,
}

export default FormDeviceToggle;